// ** Entorno de ejecución y tiempos de sesión.
//
// El entorno se declara en los archivos .env con la variable `ENVIROMENT` (dev / test /
// production). CRA solo inyecta en el bundle las variables con prefijo REACT_APP_, así que
// `craco.config.js` la republica como `process.env.REACT_APP_ENVIROMENT`; aquí se leen las
// dos para que el módulo siga funcionando si alguien define la versión prefijada a mano.

const rawEnviroment =
  process.env.REACT_APP_ENVIROMENT ?? process.env.ENVIROMENT ?? ''

export const APP_ENVIROMENT = rawEnviroment.trim().toLowerCase()

// ** ¿Estamos en desarrollo?
//
// Se acepta `dev` (el valor que usa .env) y también `development` y `local` por si el
// despliegue los nombra distinto. Como respaldo se toma NODE_ENV === 'development', que es
// lo que pone `yarn start`: así un .env sin ENVIROMENT no deja el modo dev apagado.
export const IS_DEV_ENVIROMENT =
  ['dev', 'development', 'local'].includes(APP_ENVIROMENT) ||
  (APP_ENVIROMENT === '' && process.env.NODE_ENV === 'development')

// ** Cierre por inactividad.
//
// En test y producción la sesión es corta a propósito (4 min, con aviso 60 s antes) porque
// es una app de pagos. En desarrollo esos 4 min obligan a volver a loguearse mientras se
// lee código o se depura, así que el mismo temporizador se estira a 8 h con un aviso de
// 5 min. Los valores viven aquí, y no en el contexto, para que el entorno sea el único
// interruptor y no haya que tocar la lógica del timer.
const SESSION_TIMEOUTS = {
  production: {
    timeout: 240_000,
    promptBeforeIdle: 60_000
  },
  development: {
    timeout: 28_800_000,
    promptBeforeIdle: 300_000
  }
}

export const SESSION_TIMEOUT = IS_DEV_ENVIROMENT ? SESSION_TIMEOUTS.development : SESSION_TIMEOUTS.production
